import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

export type ScheduleEmptyProps = {
  /** Distingue "nenhum resultado para a busca" de "nenhuma atividade para este filtro". */
  hasSearch: boolean
  hasActiveFilters?: boolean
  onClearFilters?: () => void
}

export const ScheduleEmpty = ({
  hasSearch,
  hasActiveFilters = false,
  onClearFilters
}: ScheduleEmptyProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
      <p className="m-0 text-base font-semibold text-gray-900">
        {hasSearch ? t('schedule.empty.noResults') : t('schedule.empty.noneForFilter')}
      </p>
      {hasSearch && (
        <p className="m-0 text-2xs text-gray-700">
          {t('schedule.empty.noResultsHint')}
        </p>
      )}
      {hasActiveFilters && onClearFilters && (
        <Button
          type="button"
          variant="light"
          size="sm"
          onClick={onClearFilters}
          showTrailingIcon={false}
        >
          Limpar filtros
        </Button>
      )}
    </div>
  )
}
